module.exports = __WEBPACK_EXTERNAL_MODULE__9832__;